export const firebaseConfig = {
    configApp: {
        apiKey: "AIzaSyABSbX4b5ETeM4OkseXzXzp1aM4VHDwNsA",
        authDomain: "poplize2018.firebaseapp.com",
        databaseURL: "https://poplize2018.firebaseio.com",
        projectId: "poplize2018",
        storageBucket: "poplize2018.appspot.com",
        messagingSenderId: "134945213098"
    }
};